import React from 'react';
import PropTypes from 'prop-types';

function getCoordinatesForPercent(percent) {
    const x = Math.cos(2 * Math.PI * percent);
    const y = Math.sin(2 * Math.PI * percent);
    return [x, y];
  }

const PieChart = ({ errori, totale }) => {
    const slices = [
        { percent: errori / totale, color: '#e53935' },
        { percent: (totale - errori) / totale, color: '#2a9cf4' },
      ];
      let cumulativePercent = 0;


      const paths = slices.map((slice) => {
        const [startX, startY] = getCoordinatesForPercent(cumulativePercent);
        cumulativePercent += slice.percent;
        const [endX, endY] = getCoordinatesForPercent(cumulativePercent);
        const largeArcFlag = slice.percent > 0.5 ? 1 : 0;
        return { path: `M ${startX} ${startY} A 1 1 0 ${largeArcFlag} 1 ${endX} ${endY} L 0 0`, color: slice.color };
      });

    return (
<span>
    <svg viewBox="-1 -1 2 2" style={{ transform: 'rotate(-90deg)', height: '60px' }}>
        {paths.map(x => <path d={x.path} fill={x.color} />)}
    </svg>
    <br />
    <br />

    <span className="legendaPositivo" /> Positivo: {totale - errori} di {totale} <br />
    <span className="legendaNegativo" /> Negativo: {errori} di {totale} <br />

</span>
);
    };

PieChart.propTypes = {
    totale: PropTypes.number.isRequired,
    errori: PropTypes.number.isRequired,
};

export default PieChart;
